/* בועת הוואטסאפ מעל באנר העוגיות. 04.10.2026. ראו ty-wa-consent.css. */
(function () {
  var root = document.documentElement, banner = null, ro = null, t = 0;
  function sync() {
    var h = 0;
    if (banner && banner.isConnected) {
      var cs = getComputedStyle(banner), r = banner.getBoundingClientRect();
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < innerHeight && r.bottom >= innerHeight - 4) h = Math.ceil(innerHeight - r.top);
    }
    if (h > 0) { root.style.setProperty('--ty-wa-consent-h', h + 'px'); root.setAttribute('data-ty-wa-up', ''); }
    else root.removeAttribute('data-ty-wa-up');
  }
  function later() { sync(); clearTimeout(t); t = setTimeout(sync, 450); }
  function attach(b) {
    if (banner === b) return; banner = b;
    new MutationObserver(later).observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'open'] });
    if (window.ResizeObserver) { ro = new ResizeObserver(later); ro.observe(b); }
    later();
  }
  function find() { var b = document.getElementById('shopify-pc__banner'); if (b) attach(b); else if (banner) later(); }
  new MutationObserver(find).observe(document.body, { childList: true, subtree: true });
  addEventListener('resize', later);
  document.addEventListener('click', function () { setTimeout(later, 50); }, true);
  find(); sync();
})();
